import {BillingProvider} from "../types.ts";
import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Badge, Button, Group, Text} from "@mantine/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {enableRecord, disableRecord} from '../services/BillingProvidersService.ts';
import {useQueryClient} from '@tanstack/react-query';
import {notifySuccess, notifyError} from '../../../components/ServiceNotifications.tsx';

export const useTableColumns = (onRecordClick?: (record: BillingProvider) => void) => {
    const queryClient = useQueryClient();

    const handleEnable = async (id: string) => {
        try {
            await enableRecord(id);
            notifySuccess('Billing Provider enabled');
            queryClient.invalidateQueries({ queryKey: ['billing-providers'] });
        } catch (e) {
            notifyError(e);
        }
    };

    const handleDisable = async (id: string) => {
        try {
            await disableRecord(id);
            notifySuccess('Billing Provider disabled');
            queryClient.invalidateQueries({ queryKey: ['billing-providers'] });
        } catch (e) {
            notifyError(e);
        }
    };

    const columns: DataTableColumn<BillingProvider>[] = [
        {
            accessor: 'name',
            title: I18n.get('Billing Provider Name'),
            width: '1fr',
            render: (item: BillingProvider) => (
                <Text
                    c="blue"
                    style={{ cursor: 'pointer' }}
                    onClick={() => onRecordClick?.(item)}
                >
                    {item.name}
                </Text>
            ),
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: BillingProvider) => item.status && item.status === 'Enabled' ?
                <Badge color={'green'}>Enabled</Badge> : <Badge color={'red'}>Disabled</Badge>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: BillingProvider) => formatTimestamp(item.created),
        },
        {
            accessor: 'actions',
            title: 'Actions',
            render: (record: BillingProvider) => (
                <Group gap="xs">
                    {record.status === 'Disabled' && (
                        <Button size="xs" onClick={() => handleEnable(record.id)}>
                            Enable
                        </Button>
                    )}
                    {record.status === 'Enabled' && (
                        <Button size="xs" color="red" onClick={() => handleDisable(record.id)}>
                            Disable
                        </Button>
                    )}
                </Group>
            )
        },

    ];

    return {
        columns,
    }
}
